import React from 'react';

function ChatListItem({ chat, isSelected, onClick, formatTime }) {
  const unread = !!chat.unread;
  const initials = (chat.phone_number || '').replace('+', '').slice(-2).toUpperCase();

  return (
    <li
      onClick={onClick}
      className={`
        flex items-center gap-3 p-4 cursor-pointer border-b border-slate-100
        transition-all duration-200
        ${isSelected 
          ? 'bg-gradient-to-r from-brand-primary/10 to-slate-50 border-l-4 border-l-brand-primary' 
          : 'hover:bg-slate-50'
        }
      `}
    >
      {/* Avatar */}
      <div 
        className={`
          w-12 h-12 rounded-full flex items-center justify-center 
          flex-shrink-0 font-bold text-sm font-montserrat shadow-sm
          transition-all duration-200
          ${unread 
            ? 'bg-gradient-to-br from-brand-green to-brand-green/80 text-white scale-105 shadow-md' 
            : 'bg-slate-200 text-slate-600'
          }
        `}
      >
        {initials || '👤'}
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2 mb-1">
          <div 
            className={`
              text-sm truncate font-montserrat
              ${unread ? 'font-extrabold text-slate-900' : 'font-semibold text-slate-700'}
            `}
          >
            {chat.phone_number}
          </div>
          <div className="text-xs text-slate-500 flex-shrink-0 font-montserrat">
            {formatTime(chat.updated_at)}
          </div>
        </div>
        
        <div className="flex items-center gap-2">
          <div 
            className={`
              text-sm truncate font-montserrat
              ${unread ? 'font-semibold text-slate-700' : 'text-slate-500'}
            `}
          >
            {chat.last_message || 'Sin mensajes'}
          </div>
          {unread && (
            <div className="w-2.5 h-2.5 rounded-full bg-brand-green flex-shrink-0 animate-pulse shadow-sm" />
          )}
        </div>
      </div>
    </li>
  );
}

export default ChatListItem;